import React, {Fragment} from 'react';
import moment from "moment"
import MomentUtils from "@date-io/moment"
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from "@material-ui/pickers"
import { backendDateFormat, fieldDateFormat } from "../../../constants"
const DateFilter = ({filterOption, filterMenu, keyParam, onFieldChange}) => {
    return(
        <Fragment>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                    views={filterMenu[keyParam].views ? filterMenu[keyParam].views:['date']}
                    label={filterMenu[keyParam].title}
                    format={filterMenu[keyParam].format ? filterMenu[keyParam].format:fieldDateFormat}
                    margin="normal"
                    id={keyParam}
                    fullWidth
                    disableFuture={filterMenu[keyParam].disableFuture?true:false}
                    placeholder={filterMenu[keyParam].title}
                    InputLabelProps={{ shrink: true }}
                    value={filterOption[keyParam] ? filterOption[keyParam]:null}
                    onChange={(data, value) => onFieldChange(keyParam, data ? moment(data).format(filterMenu[keyParam].format ? filterMenu[keyParam].format:backendDateFormat):data)}
                    inputVariant="outlined"
                />
            </MuiPickersUtilsProvider>
        </Fragment>
    )
}
export default DateFilter;